import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.DoctorEstranged,
  voices: {
    main: {
      description:
        "older refined tenor-baritone, precise transatlantic diction, dry mystic authority, silk robe softness over crackling urgency, intimate studio mic with faint arcane shimmer",
      seed: 10037,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "Open your eyes, reality is but an illusion." },
      { id: "select_2", text: "By the Vishanti, Estranged is here!" },
      { id: "select_3", text: "Did someone call Doctor Estranged?" },
      { id: "select_4", text: "I see you have need of Doctor Estranged." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Magic and science, in perfect unison. This should be interesting…",
      },
      {
        id: "spawn_2",
        text: "I can hardly contain this energy, Bruce. I don't know how you do it…",
      },
      {
        id: "spawn_3",
        text: "Magic is not the only invisible force in play here…",
      },
      {
        id: "spawn_4",
        text: "Forget the Four. We two make quite the pair, Susan!",
      },
      {
        id: "spawn_5",
        text: "Once I saved lives with a scalpel. Now I do it with a spell.",
      },
      {
        id: "spawn_6",
        text: "The Vishanti sent me to the Ancient One. It was my destiny.",
      },
      {
        id: "spawn_7",
        text: "Some call me arrogant. Mostly they are jealous.",
      },
      {
        id: "spawn_8",
        text: "The Sanctum Sanctorum is my refuge, my fortress.",
      },
      {
        id: "spawn_9",
        text: "Every spell cast has its price, and my debt is deep.",
      },
      {
        id: "spawn_10",
        text: "Everything most decidedly does not happen for a reason.",
      },
      {
        id: "spawn_11",
        text: "The occult threats to this world are many, and they grow stronger.",
      },
      {
        id: "spawn_12",
        text: "By Oshtur, there are baby wizards everywhere these days. If I had the patience, I would open a school.",
      },
      {
        id: "spawn_13",
        text: "What are they like, these other worlds where I do not exist?",
      },
      {
        id: "spawn_14",
        text: "Doom is a powerful magic adept. I expect we will face each other again…soon.",
      },
      { id: "spawn_15", text: "There is only one Sorcerer Supreme." },
      { id: "spawn_16", text: "When science failed me, magic was there." },
      {
        id: "spawn_17",
        text: "All those crises I quietly put out, you have no idea!",
      },
      {
        id: "spawn_18",
        text: "As Sorcerer Supreme, I oversee other magical adepts.",
      },
      {
        id: "spawn_19",
        text: "I would knit the dimensions back together if it were within my power.",
      },
      {
        id: "spawn_20",
        text: "Magic is not to be owned, but to be felt. Experienced. Lived.",
      },
      {
        id: "spawn_21",
        text: "The Time Entanglement is a vexing problem, even for the Sorcerer Supreme.",
      },
    ],
    respawn: [
      {
        id: "respawn_1",
        text: "Mortal pain is no match for the Sorcerer Supreme!",
      },
      { id: "respawn_2", text: "The Sorcerer Supreme lives once more!" },
      { id: "respawn_3", text: "The Mystic Arts won't fail me again." },
      { id: "respawn_4", text: "Hands are shaking again. Focus!" },
      { id: "respawn_5", text: "By the Shades of the Seraphim, I return!" },
      { id: "respawn_6", text: "I have unfinished business here." },
      { id: "respawn_7", text: "The Sorcerer Supreme returns!" },
      { id: "respawn_8", text: "The doctor is in." },
    ],
    ult_ally: [{ id: "ult_ally", text: "I unleash the Vishanti's power!" }],
    ult_enemy: [{ id: "ult_enemy", text: "By the Eye of Agamotto!" }],
    ability2: [
      { id: "ability2_1", text: "I purge the darkness!" },
      { id: "ability2_2", text: "Out, dark magic!" },
      { id: "ability2_3", text: "Leave me, darkness!" },
    ],
    ability3: [
      { id: "ability3_1", text: "(cast) I'm opening a portal!" },
      { id: "ability3_2", text: "(generate portal) Pentagram of Farallah." },
      { id: "ability3_3", text: "(generate portal) A shortcut through space." },
    ],
    kill: [
      { id: "kill_1", text: "That much closer to victory." },
      { id: "kill_2", text: "The Eye of Agamotto foresaw this." },
      { id: "kill_3", text: "By Oshtur's Bane, we overcome!" },
      {
        id: "kill_4",
        text: "By the Fangs of Farallah, that was a fine battle!",
      },
      { id: "kill_5", text: "The Winds of Watoomb blow fair this day!" },
      { id: "kill_6", text: "Another falls to the Sorcerer Supreme." },
      { id: "kill_7", text: "Feel no shame in defeat by Doctor Estranged." },
      {
        id: "kill_8",
        text: "Ancient One, I hope my successes make you proud.",
      },
      { id: "kill_9", text: "The Vishanti foresaw this." },
    ],
    multikill: [
      { id: "multikill_1", text: "Three is a powerful number." },
      { id: "multikill_2", text: "Who else among us has three?" },
      { id: "multikill_3", text: "Three! A tribute to my powers." },
      { id: "multikill_4", text: "Five? A notable streak." },
      {
        id: "multikill_5",
        text: "Five! Surely the remaining enemies will avoid me.",
      },
      { id: "multikill_6", text: "Five! The Vishanti favor me." },
      {
        id: "multikill_7",
        text: "Ha, next time I might let someone else help.",
      },
      {
        id: "multikill_8",
        text: "Hahaha, it's difficult to keep up with me, I know.",
      },
      { id: "multikill_9", text: "All fall before the Sorcerer Supreme!" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "My life was in peril. Thank you." },
      { id: "low_hp_2", text: "A timely intervention!" },
    ],
    healed: [
      { id: "healed_1", text: "I am strengthened for battle." },
      { id: "healed_2", text: "Good medicine." },
      { id: "healed_3", text: "My body is rejuvenated." },
      { id: "healed_4", text: "Ah, healing energy." },
    ],
  },
} satisfies VoiceScript;

export default script;
